import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
    const achievementsBlock = e.target.querySelector('.achievements__block')

    if (achievementsBlock) {
        const jsAchievementsSlider = achievementsBlock.querySelector('.js-achievements-slider')

        if (jsAchievementsSlider) {
            const splideInstance = new Splide(jsAchievementsSlider, {
                arrows: false,
                perMove: 1,
                type: 'slide',
                autoWidth: true,
                pagination: false,
            })
            if (achievementsBlock.querySelector('.js-achievements-slider').classList.contains('splide')) {
                splideInstance.mount()
            }
        }
    }
})
